/**
 * @generated SignedSource<<aebc3f12db307d89bc1768cd82098d72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
export type ClaimSlotForRequestInput = {
  requestBookingId: string;
  targetSlotId: string;
};
export type useClaimSlotForRequestMutation$variables = {
  input: ClaimSlotForRequestInput;
};
export type useClaimSlotForRequestMutation$data = {
  readonly responsePayload: {
    readonly draftBooking: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
    readonly targetSlot: {
      readonly availability?: SlotAvailability;
      readonly id?: string;
      readonly isLocked?: boolean;
      readonly lockedUntil?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useClaimSlotForRequestMutation = {
  response: useClaimSlotForRequestMutation$data;
  variables: useClaimSlotForRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedUntil",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useClaimSlotForRequestMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "ClaimSlotForRequestPayload",
        "kind": "LinkedField",
        "name": "claimSlotForRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "draftBooking",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "targetSlot",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useClaimSlotForRequestMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "ClaimSlotForRequestPayload",
        "kind": "LinkedField",
        "name": "claimSlotForRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "draftBooking",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "targetSlot",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cfb11771bbc6276bc5d43d474f654b5b",
    "id": null,
    "metadata": {},
    "name": "useClaimSlotForRequestMutation",
    "operationKind": "mutation",
    "text": "mutation useClaimSlotForRequestMutation(\n  $input: ClaimSlotForRequestInput!\n) {\n  responsePayload: claimSlotForRequest(input: $input) {\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n    draftBooking {\n      __typename\n      id\n    }\n    targetSlot {\n      __typename\n      ... on TimeSlot {\n        id\n        lockedUntil\n        availability\n        isLocked\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "92d3b4867f519de058a34ce86ef997ee";

export default node;
